import React from 'react';
import { Bundle } from '@ali/visualengine';
import {
  getArraySetterSnippet,
  getCnSelectSetter,
  getDataOriginSetterSnippet,
  getMixedSetterSnippet,
  getObjectSetterSnippet,
} from '@/common/manager/setter-snippet';
import { getJSExpressionPrototype } from '@/common/manager/common-style';
import { ParamSelectSetter } from '@/common/setter/param-select-setter';
import { __dataSource__ } from '@/common/util/expr-const';
import { getStatusDataSource } from '@/common/util/prototype-util';

// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export default Bundle.createPrototype({
  title: '详情信息',
  componentName: 'CnDetailInfo',
  category: '布局',
  snippets: [
    {
      screenshot:
        'https://img.alicdn.com/imgextra/i1/O1CN01zTQuch1BtsRe5t6f4_!!6000000000004-0-tps-712-224.jpg',
      label: 'CnDetailInfo',
      schema: {
        componentName: 'CnDetailInfo',
        props: {},
      },
    },
  ],
  isContainer: false,
  canHovering: true,
  canSelecting: true,
  canDragging: true,
  enableCopy: true,
  configure: [
    {
      name: 'isCnDetailInfo',
      title: 'isCnDetailInfo',
      initialValue: true,
      display: 'none',
    },
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
    {
      name: 'title',
      title: '详情名称',
      display: 'inline',
      initialValue: 'DetailInfo1',
      setter: 'StringSetter',
    },
    getDataOriginSetterSnippet({
      display: 'none',
    }),
    {
      name: 'staticInfo',
      title: '静态数据',
      display: 'plain',
      setter: getObjectSetterSnippet({
        items: [
          {
            name: 'title',
            title: '标题',
            setter: getMixedSetterSnippet({
              setters: [
                {
                  componentName: 'CnI18nSetter',
                  title: '字符串',
                },
                {
                  componentName: 'ParamSelectSetter',
                  props: {
                    ParamSelectSetterComponent: ParamSelectSetter,
                    configList: [
                      {
                        groupName: '其他数据',
                        groupExprName: __dataSource__,
                        needSecondParam: true,
                      },
                    ],
                  },
                  title: '选择参数',
                },
                getJSExpressionPrototype({
                  type: 'base',
                }),
              ],
            }),
          },
          {
            name: 'description',
            title: '描述',
            setter: getMixedSetterSnippet({
              setters: [
                {
                  componentName: 'CnI18nSetter',
                  title: '字符串',
                },
                // getArraySetterSnippet({
                //   configure: [
                //     {
                //       isRequired: true,
                //       name:'',
                //       title:'文案',
                //       setter:'CnI18nSetter'
                //     }
                //   ]
                // }),
                {
                  componentName: 'ParamSelectSetter',
                  props: {
                    ParamSelectSetterComponent: ParamSelectSetter,
                    configList: [
                      {
                        groupName: '其他数据',
                        groupExprName: __dataSource__,
                        needSecondParam: true,
                      },
                    ],
                  },
                  title: '选择参数',
                },
                getJSExpressionPrototype({
                  type: 'base',
                }),
              ],
            }),
          },
          {
            name: 'avatar',
            title: '左侧头像',
            setter: getMixedSetterSnippet({
              setters: [
                {
                  componentName: 'StringSetter',
                  title: '字符串',
                },
                {
                  componentName: 'ParamSelectSetter',
                  props: {
                    ParamSelectSetterComponent: ParamSelectSetter,
                    configList: [
                      {
                        groupName: '其他数据',
                        groupExprName: __dataSource__,
                        needSecondParam: true,
                      },
                    ],
                  },
                  title: '选择参数',
                },
                getJSExpressionPrototype({
                  type: 'base',
                }),
              ],
            }),
          },
          {
            name: 'status',
            title: '标签状态',
            setter: getMixedSetterSnippet({
              setters: [
                getCnSelectSetter({
                  options: getStatusDataSource(),
                }),
                {
                  componentName: 'ParamSelectSetter',
                  props: {
                    ParamSelectSetterComponent: ParamSelectSetter,
                    configList: [
                      {
                        groupName: '其他数据',
                        groupExprName: __dataSource__,
                        needSecondParam: true,
                      },
                    ],
                  },
                  title: '选择参数',
                },
                getJSExpressionPrototype({
                  type: 'base',
                }),
              ],
            }),
          },
          {
            name: 'tagText',
            title: '标签文案',
            setter: getMixedSetterSnippet({
              setters: [
                {
                  componentName: 'CnI18nSetter',
                  title: '字符串',
                },
                {
                  componentName: 'ParamSelectSetter',
                  props: {
                    ParamSelectSetterComponent: ParamSelectSetter,
                    configList: [
                      {
                        groupName: '其他数据',
                        groupExprName: __dataSource__,
                        needSecondParam: true,
                      },
                    ],
                  },
                  title: '选择参数',
                },
                getJSExpressionPrototype({
                  type: 'base',
                }),
              ],
            }),
          },
        ],
      }),
    },
  ],
});
